<!--
  网上缴费
  Lovi 2020-2-18
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      class="gradient"
      :title="$t('common.selectOperator')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <div class="bg"></div>
      <div class="operator-wrap">
        <div class="search">
          <van-search
            v-model="searchVal"
            :placeholder="$t('common.enterOperator')"
          />
        </div>
        <div class="operator-list">
          <scroll ref="scroll" :data="list">
            <van-cell-group
              v-for="(item, index) in list"
              :key="index"
              @click="clickOperator(item)"
            >
              <van-cell :title="item.name" />
            </van-cell-group>
          </scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    operatorList: {
      //类型列表
      type: Array,
      default: function() {
        return [];
      }
    },
    curIndex: {
      //当前银行卡
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      searchVal: "", //搜索关键字
      list: [] //运营商列表
    };
  },
  created() {
    this.list = this.operatorList;
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      this.$emit("update:operatorFlag", false);
    },
    clickOperator(data) {
      this.$emit("getCurOperator", data);
      this.$emit("update:operatorFlag", false);
    }
  },
  watch: {
    searchVal: {
      handler(obj) {
        let vm = this;
        let arr = [];
        for (let i = 0; i < vm.operatorList.length; i++) {
          if (vm.operatorList[i].name.indexOf(obj) != -1) {
            arr.push(vm.operatorList[i]);
          }
        }
        vm.list = arr;
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}

.operator-wrap {
  position: absolute;
  top: 15px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(120, 174, 249, 0.25);
  border-radius: 8px;
  overflow: hidden;
}

.search {
  padding: 10px;
  /deep/.van-search {
    padding: 0;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 20px;
    border: 1.1px solid #e4e4e4;
    .van-search__content {
      background: transparent;
      .van-cell {
        align-items: center;
        padding: 0 6px 0 0;
      }
    }
  }
}

.operator-list {
  position: absolute;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  .van-hairline--top-bottom:last-child::after {
    // border-bottom: 0;
  }
  /deep/.van-cell__title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
